import { render } from "./NavMenu.vue?vue&type=template&id=49962d0e&scoped=true&ts=true"
import script from "./NavMenu.vue?vue&type=script&lang=ts"
export * from "./NavMenu.vue?vue&type=script&lang=ts"

import "./NavMenu.vue?vue&type=style&index=0&id=49962d0e&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49962d0e"]])

export default __exports__